module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "bigAndBold"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v(" / ")]), _vm._v("1op.eu "), _c('span', {
    staticClass: "grey"
  }, [_vm._v(" / ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Extremely")]), _vm._v(" private way to send your messages and passwords in realtime. Fully encrypted using "), _c('b', [_vm._v("RSA-2048")]), _vm._v(" for messages and "), _c('b', [_vm._v("AES-256")]), _vm._v(" to transmit their public keys.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dc65d2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 171
// module chunks = 2